import styled from '@emotion/styled';
import { uiTheme as t } from 'Components/ui';

interface DateTimeInputProps {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  /** Los FormField no asocian label/input; el aria-label da el nombre accesible. */
  ariaLabel: string;
  /** Pinta el borde en rojo cuando el campo tiene un error de validación. */
  invalid?: boolean;
}

// Calca de TextInput de Instructores: ese primitivo no admite `type`, y el
// datetime-local necesita el suyo propio.
const Field = styled.input<{ invalid: boolean }>(({ invalid }) => ({
  width: '100%',
  boxSizing: 'border-box',
  padding: '10px 13px',
  border: `1px solid ${invalid ? t.color.danger : t.color.inputBorder}`,
  borderRadius: t.radius.sm,
  background: t.color.inputBg,
  fontFamily: t.font,
  fontSize: 14,
  color: t.color.title,
  outline: 'none',
  transition: 'border-color 0.15s ease',
  '&:focus': { borderColor: invalid ? t.color.danger : t.color.primary },
}));

/**
 * Primitivo de formulario: fecha y hora en la zona local del usuario.
 * El valor viaja como `YYYY-MM-DDTHH:mm`; la conversión a ISO es del envío.
 */
const DateTimeInput = ({ value, onChange, onBlur, ariaLabel, invalid = false }: DateTimeInputProps) => (
  <Field
    type="datetime-local"
    value={value}
    aria-label={ariaLabel}
    onChange={e => onChange(e.target.value)}
    onBlur={onBlur}
    invalid={invalid}
  />
);

export default DateTimeInput;
